"use client"

import { Col, Row, RowProps } from "antd"
import Title from "@/components/common/Typography/Title"
import { useTranslation } from "react-i18next"
import PromotionItemSkeleton from "./PromotionItem.skeleton"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

type PromotionsSkeletonProps = RowProps & {
}

const PromotionsSkeleton = ({ ...props }: PromotionsSkeletonProps) => {
  const { t } = useTranslation()
  const isDesktop = useIsDesktop()

  return (
    <Row {...props} style={{ marginBottom: '3rem', ...props.style }}>
      <Col span={24}>
        <Row style={{ marginInline: '-0.5rem' }} justify="space-between" align="middle">
          <Col style={{ paddingInline: '0.5rem' }}>
            <Title
              level={3}
              style={{
                margin: 0,
                marginBottom: '0.5rem'
              }}
            >
              {t("promotion.prmotions_for_you")}
            </Title>
          </Col>
        </Row>

      </Col>
      <Col span={24}>
        {isDesktop ? (
          <Row gutter={[10, 10]}>
            <Col xl={8} md={12} sm={24} xs={24}>
              <PromotionItemSkeleton />
            </Col>
          </Row>
        ) : (
          <div className="home__promotions--list">
            <div className="home__promotions--item">
              <PromotionItemSkeleton />
            </div>
          </div>
        )}
      </Col>
    </Row>
  )
}

export default PromotionsSkeleton